<div class="ui-kit title social-networks button" [ngClass]="btnStyle">
  <div class="facebook-option">
    <img src="../../../../../../assets/icons/Trazado 326.png" />
    <a> {{ btnLabel | translate }} </a>
  </div>
</div>
